import { ApiComponentName } from '../_types/fund-card-api';
import riskDisk from '../../../../foundational/ishares/icons/risk-indicators-nl-bg.png';
import riskScale from '../../../../foundational/ishares/icons/risk-indicators-nl-overlay.png';

export const baseApiComponents: ApiComponentName[] = [
	'fundheader',
	'keyfundfacts',
];

export const fundCardConfig = {
	prodUrl: `https://api.blackrock.com`,
	testUrl: `https://api-test.blackrock.com`,
	stageUrl: `https://api-staging.blackrock.com`,
};

export const testRiskImages = {
	riskDisk,
	riskScale,
};
